import { motion } from "framer-motion";
import { Reveal } from "@/lib/reveal";
import { useLanguage } from "@/context/LanguageContext";

export const Process = () => {
  const { t } = useLanguage();
  const steps = t.process.steps || [];

  return (
    <section id="process" data-testid="process" className="py-24 md:py-32">
      <div className="container-x grid lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-28">
            <Reveal className="overline font-bold tracking-[0.2em]">{t.process.overline}</Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-6 text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight text-foreground leading-[1.1]">
                {t.process.title}
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-6 text-base sm:text-lg text-foreground/80 font-medium leading-relaxed max-w-sm">
                {t.process.desc}
              </p>
            </Reveal>
          </div>
        </div>

        <div className="lg:col-span-8">
          {steps.map((p, i) => (
            <motion.div
              key={p.n}
              data-testid={`process-${p.n}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] }}
              className="group grid grid-cols-[auto_1fr] gap-6 md:gap-10 py-10 border-b border-border first:border-t"
            >
              <div className="text-5xl md:text-7xl font-extrabold tracking-tighter text-border group-hover:text-accent transition-colors duration-500">
                {p.n}
              </div>
              <div className="pt-2 md:pt-4">
                <h3 className="text-2xl md:text-3xl font-bold tracking-tight text-foreground">{p.title}</h3>
                <p className="mt-3 text-base sm:text-lg text-foreground/80 font-medium leading-relaxed max-w-md">{p.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
